export const TRACK_AUDIO_CALL = 'TRACK_AUDIO_CALL';
export const TRACK_VIDEO_CALL = 'TRACK_VIDEO_CALL';
export const AUDIO_UNMUTE_BY_USER = 'AUDIO_UNMUTE_BY_USER';
export const WEB_CONFERENCE_ENABLED = 'WEB_CONFERENCE_ENABLED';
export const WEB_CONFERENCE_DISABLED = 'WEB_CONFERENCE_DISABLED';
